import { useParentSize as useVisxParentSize } from '@visx/responsive';

const useParentSize = (): [React.RefObject<HTMLDivElement>, string, string] => {
  const { parentRef, width, height } = useVisxParentSize();

  return [parentRef, `${width}px`, `${height}px`];
};

export default useParentSize;
